import { createJSONRequest } from '../../../api/create-request'

/**
 * Get testimonials for an actor
 */
export const getTestimonialsByActor = (actorId) => createJSONRequest({
  method: 'GET',
  url: `/api/actors/${actorId}/testimonials`
})

/**
 * Create a new testimonial
 */
export const createTestimonial = (actorId, data) => createJSONRequest({
  method: 'POST',
  url: `/api/actors/${actorId}/testimonials`,
  data
})

/**
 * Update an existing testimonial
 */
export const updateTestimonial = (actorId, testimonialId, data) => createJSONRequest({
  method: 'PUT',
  url: `/api/actors/${actorId}/testimonials/${testimonialId}`,
  data
})

/**
 * Update testimonial visibility
 */
export const updateTestimonialVisibility = (actorId, testimonialId, data) => createJSONRequest({
  method: 'PUT',
  url: `/api/actors/${actorId}/testimonials/${testimonialId}/visibility`,
  data
})

/**
 * Add receiver response to testimonial
 */
export const addTestimonialResponse = (actorId, testimonialId, data) => createJSONRequest({
  method: 'POST',
  url: `/api/actors/${actorId}/testimonials/${testimonialId}/response`,
  data
})

/**
 * Delete a testimonial
 */
export const deleteTestimonial = (actorId, testimonialId) => createJSONRequest({
  method: 'DELETE',
  url: `/api/actors/${actorId}/testimonials/${testimonialId}`
})

/**
 * Get testimonial statistics for an actor
 */
export const getTestimonialStatistics = (actorId) => createJSONRequest({
  method: 'GET',
  url: `/api/actors/${actorId}/testimonials/statistics`
})

/**
 * Get user's testimonials (given and received)
 */
export const getUserTestimonials = () => createJSONRequest({
  method: 'GET',
  url: '/api/user/testimonials'
})

/**
 * Get user's given testimonials
 */
export const getUserGivenTestimonials = () => createJSONRequest({
  method: 'GET',
  url: '/api/user/testimonials/given'
})

/**
 * Get user's received testimonials
 */
export const getUserReceivedTestimonials = () => createJSONRequest({
  method: 'GET',
  url: '/api/user/testimonials/received'
})

/**
 * Get user testimonial statistics
 */
export const getUserTestimonialStatistics = () => createJSONRequest({
  method: 'GET',
  url: '/api/user/testimonials/statistics'
})

/**
 * Get relationship types for testimonials
 */
export const getRelationshipTypes = () => createJSONRequest({
  method: 'GET',
  url: '/api/testimonials/relationship-types'
})

/**
 * Get eligible authors with role information
 */
export const getEligibleAuthors = (actorId) => createJSONRequest({
  method: 'GET',
  url: `/api/actors/${actorId}/testimonials/eligible-authors`
})

/**
 * Approve a pending testimonial
 */
export const approveTestimonial = (actorId, testimonialId) => createJSONRequest({
  method: 'POST',
  url: `/api/actors/${actorId}/testimonials/${testimonialId}/approve`
})

/**
 * Reject a pending testimonial
 */
export const rejectTestimonial = (actorId, testimonialId) => createJSONRequest({
  method: 'POST',
  url: `/api/actors/${actorId}/testimonials/${testimonialId}/reject`
})